/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum AnalystSection {
    AI_ANALYSIS = 'AI_ANALYSIS',
    FRAUD_CONTACTS = 'FRAUD_CONTACTS',
    INCIDENT_INFO = 'INCIDENT_INFO',
    INCIDENT_TRANSACTIONS = 'INCIDENT_TRANSACTIONS',
    LINKS = 'LINKS',
    RECOMMENDATIONS = 'RECOMMENDATIONS',
    TRANSACTION_FLOW = 'TRANSACTION_FLOW'
}

